import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { getCities } from '../../actions/userActions/cityAction'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DynamicTable from '../reuse_components/DynamicTable'
import CustomButton from '../subComponents/buttons/CustomButton'
import CustomPagination from '../subComponents/pagination/CustomPagination'
import SearchInput from '../subComponents/search/SearchInput'
import thIcon from "../../assets/images/thIcon.svg";
import AddCities from './AddCities'
import ItemsPerPageSelector from '../subComponents/pagination/ItemsPerPageSelector';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from '../../locales/translate';
function Cities() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [currentPage, setCurrentPage] = useState(1)
  const [cityFilters, setCityFilters] = useState({
    textSearch: '',
    countryId: '0',
  })
  const permissions = JSON.parse(localStorage.getItem('permissionsList'))
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const isLoading = useSelector((state) => state.cities_reducer.isCitiesLoading);

  // City Bodyciti
  const cityBody = {
    filter: cityFilters,
    pageNumber: currentPage,
    pageSize: itemsPerPage,
  }
  const [selected, setSelected] = useState({
    textSearch: '',
    countryId: '1',
  })
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [cityData, setCityData] = useState([]);
  useEffect(() => {
    dispatch(getCities(cityBody))
  }, [currentPage, cityFilters])
  const cities = useSelector((state) => state.cities_reducer.cities)

 useEffect(() => {
    const citiesData = cities && cities.result?.[0]?.cities || [];
    setCityData(citiesData);
  }, [cities]);

  const totalPages = cities?.totalPages || 0;
  const totalItems = cities?.totalCount || 0;
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("shortName")}`, accessor: "shortName" },
  ];
  const handleEditCity = (row) => {
    setEditData(row);
    setShowModal(true);
  };
  const actions = [
    {
      label: 'Edit City',
      icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
      permission: 'CanUpdateCity',
      handler: handleEditCity,
    },
  ];

  const handleSearch = (e) => {
    setSelected({ ...selected, ['textSearch']: e.target.value })
    if (e.target.value.length >= 1) {
      setTimeout(() => {
        setCityFilters({ ...cityFilters, ['textSearch']: e.target.value })
      }, 500)
    }
    if (e.target.value == '') {
      setCityFilters({ ...cityFilters, ['textSearch']: e.target.value })
    }
  }

  const handleAddClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleItemsPerPageChange = (value) => {
    const cityBody = {
      filter: cityFilters,
      pageNumber: firstPage,
      pageSize: value,
    }
    dispatch(getCities(cityBody));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async (newData) => {
    await dispatch(getCities(cityBody));

    setShowModal(false);
  };
  return (
    <>
    <div>
      <LoadingOverlay isVisible={isLoading} />
      <div className="main-container">
        <div className="content-wrapper">
          <div className="pagination">
            <SearchInput
              placeholder="Search"
              onChange={handleSearch}
              value={selected.textSearch}
            />
            <div className="flex-align-center">
              <div className="items-per-page-container">
                <ItemsPerPageSelector
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                />
              </div>
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
              />
              {permissions && permissions.includes("CanAddCity") && (
                <CustomButton text={t("addNew")} onClick={handleAddClick} />
              )}
            </div>
          </div>

        </div>
        <DynamicTable
          data={cityData}
          columns={columns}
          permissions={permissions}
          actions={actions}
          thIcon={thIcon}
          showPagination={totalItems > 0}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
        {showModal && (
          <AddCities
            onClose={handleCloseModal}
            editData={editData}
            onSave={handleSaveData}
          />
        )}
      </div>
      </div>
    </>
  )
}

export default Cities
